<template>
<div id="topRight">
    <div class="bg-color-black">
        <div class="cc-header">
            <div>各学校单日金额</div>
        </div>
        <div class="d-flex jc-center">
            <dv-scroll-ranking-board :config="config" class="rankChart" />
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            config: {}
        };
    },
    mounted() {
        this.initData();
        // 定时器刷新，5分钟
        let _this = this;
        setInterval(() => {
            _this.initData();
        }, 1000 * 60 * 5);
    },
    methods: {
        initData() {
            let _this = this;
            this.$http.get("/dataView/pay/getDayMoneyRank").then(res => {
                if (res.data.code === 200) {
                    var config = {
                        data: res.data.result,
                        rowNum: 8, //表格行数
                        waitTime: 1000,
                        unit: "万元", //数值单位
                    };
                    _this.config = config;
                }
            });
        }
    }
};
</script>

<style lang="scss">
#topRight {
    height: 62vh;

    .cc-header {
        height: 0.5rem;
        padding-top: 0.5rem;
        color: #fff;
        font-size: 0.3rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .rankChart {
        width: 6.5rem;
        height: 6.5rem;
        margin-top: 0.6rem;
    }

    .dv-scroll-ranking-board .ranking-column .inside-column {
        height: 0.1rem;
        border-radius: 5px;
        background: linear-gradient(to left, #00bcd4, #f59101);
    }

    .dv-scroll-ranking-board .ranking-column {
        border-bottom: 0;
    }

    .dv-scroll-ranking-board .ranking-info {
        font-size: 0.2rem;
        color: #fff;
    }

    .dv-scroll-ranking-board .ranking-info .rank {
        width: 50px;
        color: #fff;
    }

    .dv-scroll-ranking-board .row-item {
        height: 0.6rem !important;
    }
}
</style>
